import { HttpClient } from "@angular/common/http"; import { Injectable } from "@angular/core";
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CustomAlertService {
  private path = "/api/v4/custom-alerts";
  constructor(private http: HttpClient) { }

  public get(): Observable<any> {
    return this.http.get(this.path)
      .pipe(catchError(this.handleError));
  }

  public ctaClicked(): Observable<any> {
    return this.http.put(this.path, { cta_clicked: true })
      .pipe(catchError(this.handleError));
  }

  public dismissed(): Observable<any> {
    return this.http.put(this.path, { dismissed: true })
      .pipe(catchError(this.handleError));
  }

  private handleError(): Observable<any> {
    return of(undefined);
  }
}

